import { render, staticRenderFns } from "./ItemSummaryBar.vue?vue&type=template&id=f934ffb2&scoped=true"
import script from "./ItemSummaryBar.vue?vue&type=script&lang=js"
export * from "./ItemSummaryBar.vue?vue&type=script&lang=js"
import style0 from "./ItemSummaryBar.vue?vue&type=style&index=0&id=f934ffb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f934ffb2",
  null
  
)

export default component.exports